/** @jsxImportSource @emotion/react */
import {css} from '@emotion/react'

import {ThreeDotProgress} from '../../generics'


const styles = {
  root: css`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: rgba(200, 200, 200, 0.25);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    height: 60px;
    border-radius: 30px;
  `
}


const buttonStyles = (isSelected, color) => css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: ${isSelected ? color : 'transparent'};
  color: #ffffff;
  border: none;
  border-radius: 9999px; /* pill shape */
  height: 56px;
  width: 115px;
  margin: 0 2px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  outline: none;
  transition: background-color 0.2s ease-in-out;

  &:hover {
    background-color: ${isSelected ? color : 'transparent'};
  }
`



const RSVPButtons = props => {

  const {status, setStatus, isSubmitting} = props



  const updateStatus = (newStatus) => () => {
    setStatus(newStatus)
  }



  return (
    <div css={styles.root}>
      {/* Going Button */}
      <button
        css={buttonStyles(status === 'confirmed', '#4CAF50')}
        onClick={updateStatus('confirmed')}
        disabled={isSubmitting}
      >
        {(isSubmitting && status === 'confirmed') ? <ThreeDotProgress color='#fff' radius='3' /> : 'Going'}
      </button>

      <hr width='1' size='23' style={{border: '0.5px solid rgba(240, 240, 240, 0.2)'}} />
      
      {/* Not Going Button */}
      <button
        css={buttonStyles(status === 'declined', '#F44336')}
        onClick={updateStatus('declined')}
        disabled={isSubmitting}
      >
        {(isSubmitting && status === 'declined') ? <ThreeDotProgress color='#fff' radius='3' /> : 'Not Going'}
      </button>

      <hr width='1' size='23' style={{border: '0.5px solid rgba(240, 240, 240, 0.2)'}} />
      
      {/* Maybe Button */}
      <button
        css={buttonStyles(status === 'maybe', '#FEBE10')}
        onClick={updateStatus('maybe')}
        disabled={isSubmitting}
      >
        {(isSubmitting && status === 'maybe') ? <ThreeDotProgress color='#fff' radius='3' /> : 'Maybe'}
      </button>
    </div>
  )
}


export default RSVPButtons


